import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

// 获取首页菜单列表
export function listShopMenu(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopMenu.listShopMenu',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 保存菜单
export function saveShopMenu(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopMenu.saveShopMenu',
      method: 'post',
      data: {
        ...data,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新菜单
export function updateShopMenu(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopMenu.updateShopMenu',
      method: 'post',
      data: {
        ...data,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除菜单
export function deleteShopMenu(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopMenu.deleteShopMenu',
      method: 'post',
      data: {
        ...data,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}